/**
 * This file was created to mock out an API response. Once the API is finalized,
 * we will scrap this local config file.
 */
import uuid from 'uuid/v4';

import { THEME_SUPPORT } from './config/themeSupport';
import { Device, DemoFontOption, DemoFontOptionKey, LocationPalette } from './types';
import { Layout } from '@graphql/types';
import fonts from '../../../../utils/joyFonts.json';

const ALOHA_THEMES: { key: string; name: string }[] = [];
const BRANNAN_THEMES: { key: string; name: string }[] = [];

export const ACCEPTED_LAYOUT_VALUES = new Set<Layout>([Layout.aloha, Layout.brannan]);

Object.keys(THEME_SUPPORT).forEach(key => {
  if (key === 'blank') {
    //
  } else {
    const themeConfig = THEME_SUPPORT[key];
    const config = {
      key,
      name: themeConfig.name
    };
    if (themeConfig.support.aloha) {
      ALOHA_THEMES.push(config);
    }
    if (themeConfig.support.brannan) {
      BRANNAN_THEMES.push(config);
    }
  }
});

export const COLOR_OPTIONS: string[] = [
  '#efeee2',
  '#444444',
  '#7096c5',
  '#7e675b',
  '#dfce85',
  '#779559',
  '#dddddd',
  '#ea9669',
  '#dea3c2',
  '#956db1',
  '#b8564f',
  '#e0bfbe',
  '#e0e0e0',
  '#666666',
  'white',
  '#f3d983'
];

export const BASE_FONT_KEYS: DemoFontOptionKey[] = fonts.map((font: DemoFontOption) => font.key);

export const PREVIEW_FONT_KEYS: DemoFontOptionKey[] = [
  'Parisienne',
  'Great Vibes',
  'Alegreya Sans SC',
  'Dancing Script',
  'Satisfy',
  'Sacramento',
  'Clicker Script',
  'Lush Script',
  'Meddon',
  'Penna Connected',
  'Pompiere',
  'Nicgonne',
  'Josefin Sans',
  'Komu',
  'AW Conqueror Carved',
  'Stalemate',
  'Shadows Into Light Two',
  'Amatic SC',
  'Pacifico',
  'Proxima Nova',
  'Emilys Candy'
];

type CustomFont = {
  key: string;
  fontFamily: string;
  fontWeight: string;
  h1: string;
  h2: string;
  h3?: string;
  lineHeight: string;
  letterSpacing: string;
  _comment?: string;
};

const fontsByKey = (fonts as CustomFont[]).reduce(
  (acc, curr) => {
    acc[curr.key] = curr;
    return acc;
  },
  {} as { [key: string]: CustomFont }
);

const getFontOptions = (vals: DemoFontOptionKey[]): DemoFontOption[] => {
  return vals
    .filter(key => !!fontsByKey[key])
    .map(key => ({
      key,
      fontFamily: fontsByKey[key].fontFamily
    }));
};

export const PREVIEW_FONTS: DemoFontOption[] = getFontOptions(PREVIEW_FONT_KEYS);

export const BASE_FONTS = getFontOptions(BASE_FONT_KEYS).reduce((mapping, font) => {
  mapping[font.key] = font.fontFamily;
  return mapping;
}, {});

const DEVICE_DIMENSIONS: {
  [device in Device]: {
    width: number;
    height: number;
  }
} = {
  monitor: { width: 1440, height: 900 },
  tablet: { width: 768, height: 1024 },
  phone: { width: 376, height: 667 }
};

const COLOR_EGGSHELL_RGBA = [0.956, 0.952, 0.904, 1];
const COLOR_OFF_BLACK_RGBA = [0.204, 0.204, 0.204, 1];
const DEFAULT_PALETTE: LocationPalette = {
  paletteId: uuid(),
  paletteName: 'My Custom Color',
  accentColor: COLOR_EGGSHELL_RGBA,
  baseText: COLOR_OFF_BLACK_RGBA,
  baseColor: COLOR_EGGSHELL_RGBA,
  accentText: COLOR_OFF_BLACK_RGBA,
  accentLightText: false,
  baseLightText: false
};

export { ALOHA_THEMES, BRANNAN_THEMES, DEVICE_DIMENSIONS, DEFAULT_PALETTE };
